// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J6w-","content":"styles_content__3Ihc9","tableWrap":"styles_tableWrap__3IUFK"};